module.exports = {
	"GJF6001": {
		"id": "GJF6001",
		"title": "GJF6001",
		"type": "GJ",
		"collection": "W",
		"season": "F",
		"gender": "M",
		"line": "PALI",
		"purpose": "SHELL",
		"colors": [
			"RS",
			"BK",
			"MU",
			"PB"
		],
		"sizes": [
			"46 - 54",
			"XS - XL"
		],
		"status": [
			"new",
			"featured"
		],
		"name": "Gore Pro Shell 3L Jacket",
		"description": "Lorem ipsum This very comfortable jacket is made for ski touring, hiking and trekking. With 3 pockets placed on the outside and 4 pockets on the inside.",
		"cpbl": {
			"windproof": 5,
			"durable": 5,
			"waterproof": 5,
			"breathable": 4,
			"weight": 3
		},
		"op": {
			"packingvolume": 3,
			"expeditionproof": 5,
			"freedomofmovement": 4,
			"versatility": 4,
			"altitude": 5
		},
		"fabrics": [
			"GORE-TEX® Pro",
			"GORE-TEX® Pro Stretch"
		],
		"features": [
			"4 chest pockets with zippers Pit vents",
			"Fixed adjustable hood Stretch panels",
			"1 inside pocket"
		],
		"padding": "0",
		"instructions": "Test care instructions EN",
		"details": {
			"video": "http://youtube.com/moo",
			"image": [
				"D1",
				"D2",
				"D3"
			]
		}
	},
	"GJF6002": {
		"id": "GJF6002",
		"title": "GJF6002",
		"type": "GJ",
		"collection": "W",
		"season": "F",
		"gender": "M",
		"line": "PALI",
		"colors": [
			"DA",
			"BK",
			"CC",
			"MU",
			"TE"
		],
		"sizes": [
			"46 - 54",
			"XS - XL"
		],
		"name": "Gore Pro Shell 3L Pants",
		"description": "Lorem ipsum This very comfortable jacket is made for ski touring, hiking and trekking. With 3 pockets placed on the outside and 4 pockets on the inside.",
		"cpbl": {
			"windproof": 5,
			"durable": 5,
			"waterproof": 5,
			"breathable": 4,
			"weight": 3
		},
		"op": {
			"packingvolume": 3,
			"expeditionproof": 5,
			"freedomofmovement": 4,
			"versatility": 4,
			"altitude": 5
		},
		"fabrics": [
			"GORE-TEX® Pro",
			"Kevlar®"
		],
		"features": [
			"2 hand warmer pockets with zippers 2 cargo pockets with zippers",
			"Side vents",
			"Stretch panels",
			"Large Kevlar® protection area",
			"(lower leg)",
			"Long side zippers"
		],
		"padding": "0"
	},
	"GJF6003": {
		"id": "GJF6003",
		"title": "GJF6003",
		"type": "GJ",
		"collection": "W",
		"season": "F",
		"gender": "M",
		"line": "SIBU",
		"purpose": "SHELL",
		"colors": [
			"TE",
			"BK",
			"CC",
			"MU"
		],
		"sizes": [
			"46 - 54",
			"XS - XL"
		],
		"name": "Gore C-Knit Jacket",
		"description": "Lorem ipsum This very comfortable jacket is made for ski touring, hiking and trekking. With 3 pockets placed on the outside and 4 pockets on the inside.",
		"cpbl": {
			"windproof": 5,
			"durable": 3,
			"waterproof": 5,
			"breathable": 4,
			"weight": 3
		},
		"op": {
			"packingvolume": 2,
			"expeditionproof": 3,
			"freedomofmovement": 4,
			"versatility": 4,
			"altitude": 3
		},
		"fabrics": "GORE® C-KnitTM Stretch",
		"features": [
			"2 chest pockets with zippers 1 sleeve pocket with zipper Adjustable  xed hood",
			"Pit vents",
			"1 inside pocket with zipper"
		],
		"padding": "0"
	},
	"GJF6501": {
		"id": "GJF6501",
		"title": "GJF6501",
		"type": "GJ",
		"collection": "W",
		"season": "F",
		"gender": "W",
		"line": "PALI",
		"purpose": "SHELL",
		"colors": [
			"MU",
			"PB",
			"RS"
		],
		"sizes": [
			"34 - 42",
			"XS - XL"
		],
		"name": "Gore Pro Shell 3L Jacket",
		"description": "Lorem ipsum This very comfortable jacket is made for ski touring, hiking and trekking. With 3 pockets placed on the outside and 4 pockets on the inside.",
		"cpbl": {
			"windproof": 5,
			"durable": 5,
			"waterproof": 5,
			"breathable": 4,
			"weight": 3
		},
		"op": {
			"packingvolume": 3,
			"expeditionproof": 5,
			"freedomofmovement": 4,
			"versatility": 4,
			"altitude": 5
		},
		"fabrics": [
			"GORE-TEX® Pro",
			"GORE-TEX® Pro Stretch"
		],
		"features": [
			"2 chest pockets with zippers Pit vents",
			"Fixed adjustable hood Stretch panels",
			"1 inside pocket"
		],
		"padding": "0"
	},
	"GJF6502": {
		"id": "GJF6502",
		"title": "GJF6502",
		"type": "GJ",
		"collection": "W",
		"season": "F",
		"gender": "W",
		"line": "PALI",
		"colors": [
			"BZ",
			"CC",
			"PB",
			"TE"
		],
		"sizes": [
			"34 - 42",
			"XS - XL"
		],
		"name": "Gore Pro Shell 3L Pants",
		"description": "Lorem ipsum This very comfortable jacket is made for ski touring, hiking and trekking. With 3 pockets placed on the outside and 4 pockets on the inside.",
		"cpbl": {
			"windproof": 5,
			"durable": 5,
			"waterproof": 5,
			"breathable": 4,
			"weight": 3
		},
		"op": {
			"packingvolume": 3,
			"expeditionproof": 5,
			"freedomofmovement": 4,
			"versatility": 4,
			"altitude": 5
		},
		"fabrics": [
			"GORE-TEX® Pro",
			"Kevlar®"
		],
		"features": [
			"2 hand warmer pockets with zippers 2 cargo pockets with zippers",
			"Side vents",
			"Stretch panels",
			"Large Kevlar® protection area",
			"(lower leg)",
			"Long side zippers"
		],
		"padding": "0"
	},
	"GJF6503": {
		"id": "GJF6503",
		"title": "GJF6503",
		"type": "GJ",
		"collection": "W",
		"season": "F",
		"gender": "W",
		"line": "SIBU",
		"purpose": "SHELL",
		"colors": [
			"CC",
			"MU",
			"TE"
		],
		"sizes": [
			"34 - 42",
			"XS - XL"
		],
		"name": "Gore C-Knit Jacket",
		"description": "Lorem ipsum This very comfortable jacket is made for ski touring, hiking and trekking. With 3 pockets placed on the outside and 4 pockets on the inside.",
		"cpbl": {
			"windproof": 5,
			"durable": 3,
			"waterproof": 5,
			"breathable": 4,
			"weight": 3
		},
		"op": {
			"packingvolume": 2,
			"expeditionproof": 3,
			"freedomofmovement": 4,
			"versatility": 4,
			"altitude": 3
		},
		"fabrics": "GORE® C-KnitTM Stretch",
		"features": [
			"2 hand warmer pockets with zippers",
			"1 sleeve pocket with zipper",
			"1 inside pocket with zipper",
			"Adjustable  xed hood",
			"Pit vents"
		],
		"padding": "0"
	},
	"JKF6001": {
		"id": "JKF6001",
		"title": "JKF6001",
		"type": "JK",
		"collection": "W",
		"season": "F",
		"gender": "M",
		"line": "SIBU",
		"purpose": "SHELL",
		"colors": [
			"BL",
			"BK",
			"DK"
		],
		"sizes": [
			"46 - 54",
			"XS - XL"
		],
		"name": "Light Weight Stretch 3L Jacket",
		"description": "Lorem ipsum This very comfortable jacket is made for ski touring, hiking and trekking. With 3 pockets placed on the outside and 4 pockets on the inside.",
		"cpbl": {
			"windproof": 5,
			"durable": 4,
			"waterproof": 5,
			"breathable": 4,
			"weight": 4
		},
		"op": {
			"packingvolume": 4,
			"expeditionproof": 5,
			"freedomofmovement": 5,
			"versatility": 4,
			"altitude": 5
		},
		"fabrics": "Nylon Stretch 3L",
		"features": [
			"2 big mesh chest pockets with zippers",
			"2 big inside mesh pockets Self adjusting hood",
			"Anti slip binding at body hem 3d body  tting"
		],
		"padding": "0"
	},
	"JKF6002": {
		"id": "JKF6002",
		"title": "JKF6002",
		"type": "JK",
		"collection": "W",
		"season": "F",
		"gender": "M",
		"line": "PALI",
		"purpose": "SHELL",
		"colors": "CH",
		"sizes": [
			"46 - 54",
			"XS - XL"
		],
		"name": "Emergency Jacket",
		"description": "Lorem ipsum This very comfortable jacket is made for ski touring, hiking and trekking. With 3 pockets placed on the outside and 4 pockets on the inside.",
		"cpbl": {
			"windproof": 5,
			"durable": 3,
			"waterproof": 5,
			"weight": 5
		},
		"op": {
			"packingvolume": 5,
			"expeditionproof": 5,
			"freedomofmovement": 3,
			"versatility": 3,
			"altitude": 5
		},
		"fabrics": "Dyneema®",
		"features": [
			"Smallest possible packing volume Ultra lightweight",
			"(51 gramm - Size M)",
			"Windproof",
			"Waterproof"
		],
		"padding": "0"
	},
	"JKF6501": {
		"id": "JKF6501",
		"title": "JKF6501",
		"type": "JK",
		"collection": "W",
		"season": "F",
		"gender": "W",
		"line": "SIBU",
		"purpose": "SHELL",
		"colors": [
			"CC",
			"DK",
			"DR"
		],
		"sizes": [
			"34 - 42",
			"XS - XL"
		],
		"name": "Light Weight Stretch 3L Jacket",
		"description": "Lorem ipsum This very comfortable jacket is made for ski touring, hiking and trekking. With 3 pockets placed on the outside and 4 pockets on the inside.",
		"cpbl": {
			"windproof": 5,
			"durable": 4,
			"waterproof": 5,
			"breathable": 4,
			"weight": 4
		},
		"op": {
			"packingvolume": 4,
			"expeditionproof": 5,
			"freedomofmovement": 5,
			"versatility": 4,
			"altitude": 5
		},
		"fabrics": "Nylon Stretch 3L",
		"features": [
			"2 big mesh chest pockets with zippers 2 big inside mesh pockets",
			"Self adjusting hood",
			"Anti slip binding at body hem",
			"3d body  tting"
		],
		"padding": "0"
	},
	"JKW6501": {
		"id": "JKW6501",
		"title": "JKW6501",
		"type": "JK",
		"collection": "W",
		"season": "W",
		"gender": "W",
		"line": "MAIWA",
		"purpose": "MID",
		"colors": [
			"BK",
			"BZ",
			"CC",
			"TE"
		],
		"sizes": [
			"34 - 42",
			"XS - XL"
		],
		"name": "Cordura Stretch Jacket",
		"description": "Lorem ipsum This very comfortable jacket is made for ski touring, hiking and trekking. With 3 pockets placed on the outside and 4 pockets on the inside.",
		"cpbl": {
			"windproof": 3,
			"durable": 5,
			"waterproof": 3,
			"breathable": 5,
			"weight": 3
		},
		"op": {
			"packingvolume": 3,
			"expeditionproof": 2,
			"freedomofmovement": 4,
			"versatility": 4,
			"altitude": 2
		},
		"fabrics": "CORDURA® 4-way Stretch",
		"features": [
			"Full zipper",
			"4-way stretch",
			"Laser perforated back panel (for maximum ventilation)"
		],
		"padding": "0"
	},
	"PAW6001": {
		"id": "PAW6001",
		"title": "PAW6001",
		"type": "PA",
		"collection": "W",
		"season": "W",
		"gender": "M",
		"line": "PALI",
		"purpose": [
			"INSULATION",
			"DOWN"
		],
		"colors": "BK",
		"sizes": [
			"46 - 54",
			"XS - XL"
		],
		"name": "Heavy Duty Down Jacket",
		"description": "Lorem ipsum This very comfortable jacket is made for ski touring, hiking and trekking. With 3 pockets placed on the outside and 4 pockets on the inside.",
		"cpbl": {
			"windproof": 3,
			"durable": 5,
			"waterproof": 3,
			"breathable": 4,
			"weight": 2
		},
		"op": {
			"packingvolume": 2,
			"expeditionproof": 5,
			"freedomofmovement": 3,
			"versatility": 2,
			"altitude": 5
		},
		"fabrics": "CORDURA® Light Weight Ripstop",
		"features": [
			"Mesh box-wall construction No top stitching",
			"(to avoid thread breaking)",
			"2 hand warmer pockets",
			"2 chest pockets",
			"Self adjusting hood 2 wind gaiter inside"
		],
		"padding": "750 cuin water repellent traceable down"
	},
	"PAW6002": {
		"id": "PAW6002",
		"title": "PAW6002",
		"type": "PA",
		"collection": "W",
		"season": "W",
		"gender": "M",
		"line": "SIBU",
		"purpose": [
			"INSULATION",
			"DOWN"
		],
		"colors": [
			"PB",
			"CC",
			"MU",
			"BL"
		],
		"sizes": [
			"46 - 54",
			"XS - XL"
		],
		"name": "Hooded Active Down Jacket",
		"description": "Lorem ipsum This very comfortable jacket is made for ski touring, hiking and trekking. With 3 pockets placed on the outside and 4 pockets on the inside.",
		"cpbl": {
			"windproof": 4,
			"durable": 5,
			"waterproof": 3,
			"breathable": 4,
			"weight": 4
		},
		"op": {
			"packingvolume": 3,
			"expeditionproof": 5,
			"freedomofmovement": 4,
			"versatility": 5,
			"altitude": 4
		},
		"fabrics": "CORDURA® Light Weight Ripstop",
		"features": [
			"Mesh box-wall construction",
			"No top stitching",
			"(to avoid thread breaking)",
			"2 hand warmer pockets with zippers Self adjusting hood",
			"3 wind gaiters inside"
		],
		"padding": "750 cuin water repellent traceable down"
	},
	"PAW6003": {
		"id": "PAW6003",
		"title": "PAW6003",
		"type": "PA",
		"collection": "W",
		"season": "W",
		"gender": "M",
		"line": "MAIWA",
		"purpose": [
			"INSULATION",
			"DOWN"
		],
		"colors": [
			"BK",
			"BZ",
			"DA",
			"PB"
		],
		"sizes": [
			"46 - 54",
			"XS - XL"
		],
		"name": "Athletic Down Jacket",
		"description": "Lorem ipsum This very comfortable jacket is made for ski touring, hiking and trekking. With 3 pockets placed on the outside and 4 pockets on the inside.",
		"cpbl": {
			"windproof": 5,
			"durable": 3,
			"waterproof": 3,
			"breathable": 4,
			"weight": 3
		},
		"op": {
			"packingvolume": 3,
			"expeditionproof": 2,
			"freedomofmovement": 4,
			"versatility": 3,
			"altitude": 2
		},
		"fabrics": [
			"CORDURA® Light Weight Ripstop",
			"Nylon Light Weight Stretch"
		],
		"features": [
			"2 hand warmer pockets with zippers 2 chest pockets with zippers",
			"1 inside pocket with zipper",
			"1 inside pocket with Velcro Removeable and adjustable hood"
		],
		"padding": "750 cuin traceable down"
	},
	"PAW6004": {
		"id": "PAW6004",
		"title": "PAW6004",
		"type": "PA",
		"collection": "W",
		"season": "W",
		"gender": "M",
		"line": "SIBU",
		"purpose": [
			"INSULATION",
			"DOWN"
		],
		"colors": [
			"BK",
			"BL",
			"MU",
			"PB"
		],
		"sizes": [
			"46 - 54",
			"XS - XL"
		],
		"name": "Hybrid Jacket",
		"description": "Lorem ipsum This very comfortable jacket is made for ski touring, hiking and trekking. With 3 pockets placed on the outside and 4 pockets on the inside.",
		"cpbl": {
			"windproof": 4,
			"durable": 4,
			"waterproof": 3,
			"breathable": 5,
			"weight": 4
		},
		"op": {
			"packingvolume": 3,
			"expeditionproof": 5,
			"freedomofmovement": 5,
			"versatility": 4,
			"altitude": 3
		},
		"fabrics": [
			"CORDURA® Light Weight Ripstop",
			"CORDURA® 4-way Stretch",
			"Polartec® Power GridTM Fleece",
			"Polartec®  ermal Pro®"
		],
		"features": [
			"2 big mesh chest pockets",
			"2 chest pockets with zippers Mapped insulation",
			"Stretch back panel",
			"Fitted stretch  eece hood Anti slip binding at body hem"
		],
		"padding": [
			"750 cuin water repellent",
			"traceable down",
			"PrimaLoft® Gold",
			"Polartec® Alpha®"
		]
	},
	"PAW6005": {
		"id": "PAW6005",
		"title": "PAW6005",
		"type": "PA",
		"collection": "W",
		"season": "W",
		"gender": "M",
		"line": "MAIWA",
		"purpose": [
			"INSULATION",
			"DOWN"
		],
		"colors": [
			"MU",
			"BK",
			"PB"
		],
		"sizes": [
			"46 - 54",
			"XS - XL"
		],
		"name": "Light Down Insulation Jacket",
		"description": "Lorem ipsum This very comfortable jacket is made for ski touring, hiking and trekking. With 3 pockets placed on the outside and 4 pockets on the inside.",
		"cpbl": {
			"windproof": 4,
			"durable": 3,
			"waterproof": 3,
			"breathable": 4,
			"weight": 5
		},
		"op": {
			"packingvolume": 5,
			"expeditionproof": 3,
			"freedomofmovement": 5,
			"versatility": 5,
			"altitude": 3
		},
		"fabrics": [
			"CORDURA® Light Weight Ripstop",
			"Polartec® Power Stretch® Fleece"
		],
		"features": [
			"2 hand warmer pockets with zippers",
			"1 chest pocket with zipper"
		],
		"padding": [
			"750 cuin water repellent",
			"Traceable down",
			"PrimaLoft® Gold"
		]
	},
	"PAW6006": {
		"id": "PAW6006",
		"title": "PAW6006",
		"type": "PA",
		"collection": "W",
		"season": "W",
		"gender": "M",
		"line": "MAIWA",
		"purpose": [
			"INSULATION",
			"DOWN"
		],
		"colors": [
			"BK",
			"BL",
			"MU"
		],
		"sizes": [
			"46 - 54",
			"XS - XL"
		],
		"name": "Light Down Insulation Stretch Jacket",
		"description": "Lorem ipsum This very comfortable jacket is made for ski touring, hiking and trekking. With 3 pockets placed on the outside and 4 pockets on the inside.",
		"cpbl": {
			"windproof": 3,
			"durable": 3,
			"waterproof": 3,
			"breathable": 5,
			"weight": 5
		},
		"op": {
			"packingvolume": 5,
			"expeditionproof": 2,
			"freedomofmovement": 5,
			"versatility": 3,
			"altitude": 2
		},
		"fabrics": [
			"Nylon Superlight Ripstop",
			"Nylon Stretch"
		],
		"features": [
			"2 hand warmer pockets with zippers Stretch set in at back",
			"Lightweight hood"
		],
		"padding": "750 cuin traceable down"
	},
	"PAW6007": {
		"id": "PAW6007",
		"title": "PAW6007",
		"type": "PA",
		"collection": "W",
		"season": "W",
		"gender": "M",
		"line": "PALI",
		"purpose": [
			"INSULATION",
			"DOWN"
		],
		"colors": [
			"BK",
			"TE"
		],
		"sizes": [
			"46 - 54",
			"XS - XL"
		],
		"name": "Active Insulation Pants",
		"description": "Lorem ipsum This very comfortable jacket is made for ski touring, hiking and trekking. With 3 pockets placed on the outside and 4 pockets on the inside.",
		"cpbl": {
			"windproof": 5,
			"durable": 4,
			"waterproof": 3,
			"breathable": 5,
			"weight": 4
		},
		"op": {
			"packingvolume": 3,
			"expeditionproof": 5,
			"freedomofmovement": 3,
			"versatility": 2,
			"altitude": 5
		},
		"fabrics": "CORDURA® Light Weight Ripstop CORDURA® Stretch Fabric",
		"features": [
			"2 mesh pockets",
			"1 pocket with zipper Lightweight",
			"Durable",
			"Double chamber construction Long side zippers",
			"3/4 length"
		],
		"padding": "750 cuin water repellent traceable down"
	},
	"PAW6008": {
		"id": "PAW6008",
		"title": "PAW6008",
		"type": "PA",
		"collection": "W",
		"season": "W",
		"gender": "M",
		"line": "MAIWA",
		"purpose": [
			"INSULATION",
			"DOWN"
		],
		"colors": [
			"BL",
			"BK",
			"MU",
			"TE"
		],
		"sizes": [
			"46 - 54",
			"XS - XL"
		],
		"name": "Casual Down Jacket",
		"description": "Lorem ipsum This very comfortable jacket is made for ski touring, hiking and trekking. With 3 pockets placed on the outside and 4 pockets on the inside.",
		"cpbl": {
			"windproof": 4,
			"durable": 2,
			"waterproof": 3,
			"breathable": 4,
			"weight": 3
		},
		"op": {
			"packingvolume": 3,
			"expeditionproof": 2,
			"freedomofmovement": 4,
			"versatility": 2,
			"altitude": 2
		},
		"fabrics": [
			"Nylon Light Weight Ripstop",
			"Nylon Light Weight Stretch"
		],
		"features": [
			"2 hand warmer pockets with zippers 2 chest pockets with zippers",
			"1 inside pocket with zipper",
			"1 inside pocket with Velcro Removeable and adjustable hood"
		],
		"padding": "750 cuin traceable down"
	},
	"PAW6009": {
		"id": "PAW6009",
		"title": "PAW6009",
		"type": "PA",
		"collection": "W",
		"season": "W",
		"gender": "M",
		"line": "PALI",
		"purpose": [
			"INSULATION",
			"DOWN",
			"MID"
		],
		"colors": [
			"CC",
			"BK",
			"DA",
			"DK",
			"TE"
		],
		"sizes": [
			"46 - 54",
			"XS - XL"
		],
		"name": "Base Camp Hoody",
		"description": "Lorem ipsum This very comfortable jacket is made for ski touring, hiking and trekking. With 3 pockets placed on the outside and 4 pockets on the inside.",
		"cpbl": {
			"windproof": 3,
			"durable": 3,
			"waterproof": 1,
			"breathable": 5,
			"weight": 4
		},
		"op": {
			"packingvolume": 3,
			"expeditionproof": 5,
			"freedomofmovement": 5,
			"versatility": 3,
			"altitude": 3
		},
		"fabrics": [
			"Polartec® Power GridTM Fleece",
			"CORDURA® Light Weight Ripstop"
		],
		"features": "2 hand warmer pockets with zippers Front and hood with down padding",
		"padding": "750 cuin water repellent Traceable down"
	},
	"PAW6501": {
		"id": "PAW6501",
		"title": "PAW6501",
		"type": "PA",
		"collection": "W",
		"season": "W",
		"gender": "W",
		"line": "SIBU",
		"purpose": [
			"INSULATION",
			"DOWN"
		],
		"colors": [
			"CC",
			"PB",
			"WS"
		],
		"sizes": [
			"34 - 42",
			"XS - XL"
		],
		"name": "Hooded Active Down Jacket",
		"description": "Lorem ipsum This very comfortable jacket is made for ski touring, hiking and trekking. With 3 pockets placed on the outside and 4 pockets on the inside.",
		"cpbl": {
			"windproof": 4,
			"durable": 5,
			"waterproof": 3,
			"breathable": 4,
			"weight": 4
		},
		"op": {
			"packingvolume": 3,
			"expeditionproof": 5,
			"freedomofmovement": 4,
			"versatility": 5,
			"altitude": 4
		},
		"fabrics": "CORDURA® Light Weight Ripstop",
		"features": [
			"Mesh box-wall construction",
			"No top stitching",
			"(to avoid thread breaking)",
			"2 hand warmer pockets with zippers Self adjusting hood",
			"3 wind gaiters inside"
		],
		"padding": "750 cuin water repellent traceable down"
	},
	"PAW6502": {
		"id": "PAW6502",
		"title": "PAW6502",
		"type": "PA",
		"collection": "W",
		"season": "W",
		"gender": "W",
		"line": "MAIWA",
		"purpose": [
			"INSULATION",
			"DOWN"
		],
		"colors": [
			"GB",
			"WS",
			"YS"
		],
		"sizes": [
			"34 - 42",
			"XS - XL"
		],
		"name": "Athletic Down Jacket",
		"description": "Lorem ipsum This very comfortable jacket is made for ski touring, hiking and trekking. With 3 pockets placed on the outside and 4 pockets on the inside.",
		"cpbl": {
			"windproof": 5,
			"durable": 3,
			"waterproof": 3,
			"breathable": 4,
			"weight": 3
		},
		"op": {
			"packingvolume": 3,
			"expeditionproof": 2,
			"freedomofmovement": 4,
			"versatility": 2,
			"altitude": 2
		},
		"fabrics": [
			"CORDURA® Light Weight Ripstop",
			"Nylon Light Weight Stretch"
		],
		"features": [
			"2 hand warmer pockets with zippers",
			"1 inside pocket with zipper",
			"1 inside pocket with Velcro",
			"Removeable and adjustable hood"
		],
		"padding": "750 cuin traceable down"
	},
	"PAW6503": {
		"id": "PAW6503",
		"title": "PAW6503",
		"type": "PA",
		"collection": "W",
		"season": "W",
		"gender": "W",
		"line": "SIBU",
		"purpose": [
			"INSULATION",
			"DOWN"
		],
		"colors": [
			"CC",
			"MU",
			"PB",
			"WS"
		],
		"sizes": [
			"34 - 42",
			"XS - XL"
		],
		"name": "Hybrid Jacket",
		"description": "Lorem ipsum This very comfortable jacket is made for ski touring, hiking and trekking. With 3 pockets placed on the outside and 4 pockets on the inside.",
		"cpbl": {
			"windproof": 4,
			"durable": 4,
			"waterproof": 3,
			"breathable": 5,
			"weight": 4
		},
		"op": {
			"packingvolume": 3,
			"expeditionproof": 5,
			"freedomofmovement": 5,
			"versatility": 4,
			"altitude": 3
		},
		"fabrics": [
			"CORDURA® Light Weight Ripstop",
			"CORDURA® 4-way Stretch",
			"Polartec® Fleece"
		],
		"features": [
			"2 hand warmer pockets with zippers",
			"Mapped insulation",
			"Stretch back panel",
			"Fitted stretch  eece hood",
			"Anti slip binding at body hem"
		],
		"padding": [
			"750 cuin goose down",
			"Water repellent and traceable",
			"PrimaLoft® Gold",
			"Polartec® Alpha®"
		]
	},
	"PAW6504": {
		"id": "PAW6504",
		"title": "PAW6504",
		"type": "PA",
		"collection": "W",
		"season": "W",
		"gender": "W",
		"line": "MAIWA",
		"purpose": [
			"INSULATION",
			"DOWN"
		],
		"colors": [
			"PB",
			"RS",
			"YS"
		],
		"sizes": [
			"34 - 42",
			"XS - XL"
		],
		"name": "Light Down Insulation Jacket",
		"description": "Lorem ipsum This very comfortable jacket is made for ski touring, hiking and trekking. With 3 pockets placed on the outside and 4 pockets on the inside.",
		"cpbl": {
			"windproof": 4,
			"durable": 3,
			"waterproof": 3,
			"breathable": 4,
			"weight": 5
		},
		"op": {
			"packingvolume": 5,
			"expeditionproof": 3,
			"freedomofmovement": 5,
			"versatility": 5,
			"altitude": 3
		},
		"fabrics": [
			"CORDURA® Light Weight Ripstop",
			"Polartec® Fleece"
		],
		"features": "2 hand warmer pockets with zippers",
		"padding": [
			"750 cuin water repellent traceable down",
			"PrimaLoft® Gold"
		]
	},
	"PAW6505": {
		"id": "PAW6505",
		"title": "PAW6505",
		"type": "PA",
		"collection": "W",
		"season": "W",
		"gender": "W",
		"line": "MAIWA",
		"purpose": [
			"INSULATION",
			"DOWN"
		],
		"colors": [
			"BK",
			"GB",
			"RS",
			"WS",
			"RS"
		],
		"sizes": [
			"34 - 42",
			"XS - XL"
		],
		"name": "Casual Down Jacket",
		"description": "Lorem ipsum This very comfortable jacket is made for ski touring, hiking and trekking. With 3 pockets placed on the outside and 4 pockets on the inside.",
		"cpbl": {
			"windproof": 4,
			"durable": 2,
			"waterproof": 3,
			"breathable": 4,
			"weight": 3
		},
		"op": {
			"packingvolume": 3,
			"expeditionproof": 2,
			"freedomofmovement": 4,
			"versatility": 2,
			"altitude": 2
		},
		"fabrics": [
			"Nylon Light Weight Stretch",
			"Nylon Light Weight Ripstop"
		],
		"features": [
			"2 hand warmer pockets with zippers",
			"1 inside pocket with zipper",
			"Removeable and adjustable hood"
		],
		"padding": "750 cuin traceable down"
	},
	"PNF6001": {
		"id": "PNF6001",
		"title": "PNF6001",
		"type": "PN",
		"collection": "W",
		"season": "F",
		"gender": "M",
		"line": "SIBU",
		"colors": "BK",
		"sizes": [
			"46 - 54",
			"XS - XL"
		],
		"name": "Light Weight Stretch 3L Pants",
		"description": "Lorem ipsum This very comfortable jacket is made for ski touring, hiking and trekking. With 3 pockets placed on the outside and 4 pockets on the inside.",
		"cpbl": {
			"windproof": 5,
			"durable": 4,
			"waterproof": 5,
			"breathable": 4,
			"weight": 4
		},
		"op": {
			"packingvolume": 4,
			"expeditionproof": 5,
			"freedomofmovement": 5,
			"versatility": 4,
			"altitude": 4
		},
		"fabrics": "Nylon Stretch 3L Kevlar® Ripstop",
		"features": [
			"2 mesh pockets",
			"1 pocket with zipper",
			"Full length side zippers Large Kevlar® protection area (lower leg)"
		],
		"padding": "0"
	},
	"PNF6002": {
		"id": "PNF6002",
		"title": "PNF6002",
		"type": "PN",
		"collection": "W",
		"season": "F",
		"gender": "M",
		"line": "SIBU",
		"colors": [
			"BK",
			"DK",
			"TE"
		],
		"sizes": [
			"46 - 54",
			"XS - XL"
		],
		"name": "Active Flex Pants Light",
		"description": "Lorem ipsum This very comfortable jacket is made for ski touring, hiking and trekking. With 3 pockets placed on the outside and 4 pockets on the inside.",
		"cpbl": {
			"windproof": 3,
			"durable": 4,
			"waterproof": 3,
			"breathable": 5,
			"weight": 5
		},
		"op": {
			"packingvolume": 4,
			"expeditionproof": 5,
			"freedomofmovement": 5,
			"versatility": 4,
			"altitude": 3
		},
		"fabrics": [
			"Nylon Double Weave",
			"CORDURA® Stretch Double Weave Kevlar® Ripstop"
		],
		"features": [
			"2 hand warmer pockets with zippers",
			"(moisture barrier)",
			"Side mesh pockets",
			"Extreme  exible",
			"Kevlar® protection pad",
			"Non absorbing lower leg panels 4-way stretch",
			"Elasticated waist band"
		],
		"padding": "0"
	},
	"PNF6003": {
		"id": "PNF6003",
		"title": "PNF6003",
		"type": "PN",
		"collection": "W",
		"season": "F",
		"gender": "M",
		"line": "PALI",
		"colors": [
			"TE",
			"BK"
		],
		"sizes": [
			"46 - 54",
			"XS - XL"
		],
		"name": "Active Flex Pants Light",
		"description": "Lorem ipsum This very comfortable jacket is made for ski touring, hiking and trekking. With 3 pockets placed on the outside and 4 pockets on the inside.",
		"cpbl": {
			"windproof": 3,
			"durable": 4,
			"waterproof": 3,
			"breathable": 5,
			"weight": 3
		},
		"op": {
			"packingvolume": 3,
			"expeditionproof": 5,
			"freedomofmovement": 5,
			"versatility": 5,
			"altitude": 5
		},
		"fabrics": [
			"Nylon 4-way Stretch Double Weave CORDURA® 4-way Stretch",
			"Kevlar® Ripstop",
			"CORDURA® Light Weight Ripstop"
		],
		"features": [
			"2 hand warmer pockets with zippers",
			"(moisture barrier)",
			"Side mesh pockets",
			"Extreme  exible",
			"Mesh lined",
			"Large Kevlar® protection area Non absorbing lower leg panels 4-way stretch",
			"Side zipper lower leg Snow gaiter"
		],
		"padding": "0"
	},
	"PNF6004": {
		"id": "PNF6004",
		"title": "PNF6004",
		"type": "PN",
		"collection": "W",
		"season": "F",
		"gender": "M",
		"line": "MAIWA",
		"colors": [
			"TE",
			"BK",
			"DK"
		],
		"sizes": [
			"46 - 54",
			"XS - XL"
		],
		"name": "Light Weight Cordura Stretch Pants",
		"description": "Lorem ipsum This very comfortable jacket is made for ski touring, hiking and trekking. With 3 pockets placed on the outside and 4 pockets on the inside.",
		"cpbl": {
			"windproof": 3,
			"durable": 4,
			"waterproof": 3,
			"breathable": 5,
			"weight": 5
		},
		"op": {
			"packingvolume": 4,
			"expeditionproof": 2,
			"freedomofmovement": 5,
			"versatility": 3,
			"altitude": 2
		},
		"fabrics": "CORDURA® 4-way Stretch",
		"features": [
			"2 hand warmer pockets with zippers",
			"1 back pocket with zipper"
		],
		"padding": "0"
	},
	"PNF6005": {
		"id": "PNF6005",
		"title": "PNF6005",
		"type": "PN",
		"collection": "W",
		"season": "F",
		"gender": "M",
		"line": "MAIWA",
		"colors": [
			"TE",
			"BK"
		],
		"sizes": [
			"46 - 54",
			"XS - XL"
		],
		"name": "Cordura Stretch Pants",
		"description": "Lorem ipsum This very comfortable jacket is made for ski touring, hiking and trekking. With 3 pockets placed on the outside and 4 pockets on the inside.",
		"cpbl": {
			"windproof": 4,
			"durable": 5,
			"waterproof": 3,
			"breathable": 4,
			"weight": 4
		},
		"op": {
			"packingvolume": 3,
			"expeditionproof": 2,
			"freedomofmovement": 4,
			"versatility": 3,
			"altitude": 3
		},
		"fabrics": "CORDURA® Double Weave Stretch",
		"features": [
			"2 hand warmer pockets with zippers",
			"2 leg pockets with zippers",
			"1 back pocket with zipper"
		],
		"padding": "0"
	},
	"PNF6501": {
		"id": "PNF6501",
		"title": "PNF6501",
		"type": "PN",
		"collection": "W",
		"season": "F",
		"gender": "W",
		"line": "SIBU",
		"colors": "CC",
		"sizes": [
			"34 - 42",
			"XS - XL"
		],
		"name": "Light Weight Stretch 3L Pants",
		"description": "Lorem ipsum This very comfortable jacket is made for ski touring, hiking and trekking. With 3 pockets placed on the outside and 4 pockets on the inside.",
		"cpbl": {
			"windproof": 5,
			"durable": 4,
			"waterproof": 5,
			"breathable": 4,
			"weight": 4
		},
		"op": {
			"packingvolume": 4,
			"expeditionproof": 5,
			"freedomofmovement": 5,
			"versatility": 4,
			"altitude": 4
		},
		"fabrics": [
			"Nylon Stretch 3L",
			"Kevlar® Ripstop"
		],
		"features": [
			"2 mesh pockets",
			"Full length side zippers",
			"Large Kevlar® protection area (lower leg)"
		],
		"padding": "0"
	},
	"PNF6502": {
		"id": "PNF6502",
		"title": "PNF6502",
		"type": "PN",
		"collection": "W",
		"season": "F",
		"gender": "W",
		"line": "PALI",
		"colors": [
			"BK",
			"CC",
			"TE"
		],
		"sizes": [
			"34 - 42",
			"XS - XL"
		],
		"name": "Active Flex Pants",
		"description": "Lorem ipsum This very comfortable jacket is made for ski touring, hiking and trekking. With 3 pockets placed on the outside and 4 pockets on the inside.",
		"cpbl": {
			"windproof": 3,
			"durable": 4,
			"waterproof": 3,
			"breathable": 5,
			"weight": 3
		},
		"op": {
			"packingvolume": 3,
			"expeditionproof": 5,
			"freedomofmovement": 5,
			"versatility": 5,
			"altitude": 5
		},
		"fabrics": [
			"Nylon 4-way Stretch Double Weave",
			"CORDURA® 4-way Stretch",
			"Kevlar® Ripstop",
			"CORDURA® Light Weight Ripstop"
		],
		"features": [
			"2 hand warmer pockets with zippers",
			"(moisture barrier)",
			"Side mesh pockets",
			"Extreme  exible",
			"Mesh lined",
			"Large Kevlar® protection area Non absorbing lower leg panels 4-way stretch",
			"Side zipper lower leg Snow gaiter"
		],
		"padding": "0"
	},
	"PNF6503": {
		"id": "PNF6503",
		"title": "PNF6503",
		"type": "PN",
		"collection": "W",
		"season": "F",
		"gender": "W",
		"line": "MAIWA",
		"colors": [
			"BK",
			"CC",
			"DK",
			"TE"
		],
		"sizes": [
			"34 - 42",
			"XS - XL"
		],
		"name": "Light Weight Cordura Stretch Pants",
		"description": "Lorem ipsum This very comfortable jacket is made for ski touring, hiking and trekking. With 3 pockets placed on the outside and 4 pockets on the inside.",
		"cpbl": {
			"windproof": 3,
			"durable": 4,
			"waterproof": 3,
			"breathable": 5,
			"weight": 5
		},
		"op": {
			"packingvolume": 4,
			"expeditionproof": 2,
			"freedomofmovement": 5,
			"versatility": 3,
			"altitude": 2
		},
		"fabrics": "CORDURA® 4-way Stretch",
		"features": [
			"2 hand warmer pockets with zippers",
			"2 back pockets with zippers",
			"Elastic waistband"
		],
		"padding": "0"
	},
	"PNF6504": {
		"id": "PNF6504",
		"title": "PNF6504",
		"type": "PN",
		"collection": "W",
		"season": "F",
		"gender": "W",
		"line": "MAIWA",
		"colors": [
			"BK",
			"CC",
			"PB"
		],
		"sizes": [
			"34 - 42",
			"XS - XL"
		],
		"name": "Cordura Stretch Pants",
		"description": "Lorem ipsum This very comfortable jacket is made for ski touring, hiking and trekking. With 3 pockets placed on the outside and 4 pockets on the inside.",
		"cpbl": {
			"windproof": 4,
			"durable": 5,
			"waterproof": 3,
			"breathable": 4,
			"weight": 4
		},
		"op": {
			"packingvolume": 3,
			"expeditionproof": 2,
			"freedomofmovement": 4,
			"versatility": 3,
			"altitude": 3
		},
		"fabrics": "CORDURA® Double Weave Stretch",
		"features": [
			"2 hand warmer pockets with zippers",
			"2 back pocket with zippers"
		],
		"padding": "0"
	},
	"PNW6001": {
		"id": "PNW6001",
		"title": "PNW6001",
		"type": "PN",
		"collection": "W",
		"season": "W",
		"gender": "M",
		"line": "MAIWA",
		"colors": "BK",
		"sizes": [
			"46 - 54",
			"XS - XL"
		],
		"name": "MultiPurpose Hiking Pants",
		"description": "Lorem ipsum This very comfortable jacket is made for ski touring, hiking and trekking. With 3 pockets placed on the outside and 4 pockets on the inside.",
		"cpbl": {
			"windproof": 4,
			"durable": 4,
			"waterproof": 3,
			"breathable": 4,
			"weight": 3
		},
		"op": {
			"packingvolume": 2,
			"expeditionproof": 2,
			"freedomofmovement": 4,
			"versatility": 3,
			"altitude": 4
		},
		"fabrics": "Polyester Double Weave",
		"features": [
			"2 hand warmer pockets with zippers",
			"Elasticated waist band"
		],
		"padding": "0"
	},
	"PNW6501": {
		"id": "PNW6501",
		"title": "PNW6501",
		"type": "PN",
		"collection": "W",
		"season": "W",
		"gender": "W",
		"line": "MAIWA",
		"colors": "BK",
		"sizes": [
			"34 - 42",
			"XS - XL"
		],
		"name": "MultiPurpose Hiking Pants",
		"description": "Lorem ipsum This very comfortable jacket is made for ski touring, hiking and trekking. With 3 pockets placed on the outside and 4 pockets on the inside.",
		"cpbl": {
			"windproof": 4,
			"durable": 4,
			"waterproof": 3,
			"breathable": 4,
			"weight": 3
		},
		"op": {
			"packingvolume": 2,
			"expeditionproof": 2,
			"freedomofmovement": 4,
			"versatility": 3,
			"altitude": 4
		},
		"fabrics": "Polyester Double Weave",
		"features": [
			"2 hand warmer pockets with zippers",
			"2 back pockets with zippers"
		],
		"padding": "0"
	},
	"TSF6001": {
		"id": "TSF6001",
		"title": "TSF6001",
		"type": "TS",
		"collection": "W",
		"season": "F",
		"gender": "M",
		"line": "MAIWA",
		"purpose": "MID",
		"colors": [
			"RS",
			"BK",
			"BZ",
			"TE"
		],
		"sizes": [
			"46 - 54",
			"XS - XL"
		],
		"name": "Cordura Stretch Jacket",
		"description": "Lorem ipsum This very comfortable jacket is made for ski touring, hiking and trekking. With 3 pockets placed on the outside and 4 pockets on the inside.",
		"cpbl": {
			"windproof": 3,
			"durable": 5,
			"waterproof": 3,
			"breathable": 5,
			"weight": 3
		},
		"op": {
			"packingvolume": 3,
			"expeditionproof": 2,
			"freedomofmovement": 4,
			"versatility": 4,
			"altitude": 2
		},
		"fabrics": "CORDURA® 4-way Stretch",
		"features": [
			"2 chest pockets with zippers Half zipper",
			"4-way stretch",
			"Laser perforated back panel (for maximum ventilation)"
		],
		"padding": "0"
	},
	"TSF6002": {
		"id": "TSF6002",
		"title": "TSF6002",
		"type": "TS",
		"collection": "W",
		"season": "F",
		"gender": "M",
		"line": "MAIWA",
		"purpose": "MID",
		"colors": [
			"BZ",
			"BK",
			"BL",
			"PB",
			"RS"
		],
		"sizes": [
			"46 - 54",
			"XS - XL"
		],
		"name": "Light Weight Power Stretch Fleece",
		"description": "Lorem ipsum This very comfortable jacket is made for ski touring, hiking and trekking. With 3 pockets placed on the outside and 4 pockets on the inside.",
		"cpbl": {
			"windproof": 1,
			"durable": 3,
			"waterproof": 1,
			"breathable": 5,
			"weight": 5
		},
		"op": {
			"packingvolume": 4,
			"expeditionproof": 2,
			"freedomofmovement": 5,
			"versatility": 5,
			"altitude": 2
		},
		"fabrics": [
			"Polartec® Power Stretch® Fleece",
			"Polartec® Power GridTM Fleece"
		],
		"features": "Half zipper",
		"padding": "0"
	},
	"TSF6003": {
		"id": "TSF6003",
		"title": "TSF6003",
		"type": "TS",
		"collection": "W",
		"season": "F",
		"gender": "M",
		"line": "MAIWA",
		"purpose": "MID",
		"colors": [
			"RS",
			"BK",
			"BL",
			"BZ",
			"DA"
		],
		"sizes": [
			"46 - 54",
			"XS - XL"
		],
		"name": "Ultrasonic Power Stretch Fleece",
		"description": "Lorem ipsum This very comfortable jacket is made for ski touring, hiking and trekking. With 3 pockets placed on the outside and 4 pockets on the inside.",
		"cpbl": {
			"windproof": 1,
			"durable": 3,
			"waterproof": 1,
			"breathable": 5,
			"weight": 5
		},
		"op": {
			"packingvolume": 5,
			"expeditionproof": 2,
			"freedomofmovement": 5,
			"versatility": 5,
			"altitude": 2
		},
		"fabrics": "Polartec® Power Stretch® Fleece",
		"features": [
			"1 chest pocket with zipper",
			"Half zipper",
			"Ultrasonic seams"
		],
		"padding": "0"
	},
	"TSF6501": {
		"id": "TSF6501",
		"title": "TSF6501",
		"type": "TS",
		"collection": "W",
		"season": "F",
		"gender": "W",
		"line": "MAIWA",
		"purpose": "MID",
		"colors": [
			"DR",
			"TE",
			"WS",
			"YS"
		],
		"sizes": [
			"34 - 42",
			"XS - XL"
		],
		"name": "Light Weight Power Stretch Fleece",
		"description": "Lorem ipsum This very comfortable jacket is made for ski touring, hiking and trekking. With 3 pockets placed on the outside and 4 pockets on the inside.",
		"cpbl": {
			"windproof": 1,
			"durable": 4,
			"waterproof": 1,
			"breathable": 5,
			"weight": 5
		},
		"op": {
			"packingvolume": 4,
			"expeditionproof": 2,
			"freedomofmovement": 5,
			"versatility": 5,
			"altitude": 2
		},
		"fabrics": [
			"Polartec® Power GridTM Fleece",
			"Polartec® Power Stretch® Fleece"
		],
		"features": "Half zipper",
		"padding": "0"
	},
	"TSF6502": {
		"id": "TSF6502",
		"title": "TSF6502",
		"type": "TS",
		"collection": "W",
		"season": "F",
		"gender": "W",
		"line": "MAIWA",
		"purpose": "MID",
		"colors": [
			"DR",
			"MU",
			"PB",
			"WS"
		],
		"sizes": [
			"34 - 42",
			"XS - XL"
		],
		"name": "Ultrasonic Power Stretch Fleece",
		"description": "Lorem ipsum This very comfortable jacket is made for ski touring, hiking and trekking. With 3 pockets placed on the outside and 4 pockets on the inside.",
		"cpbl": {
			"windproof": 1,
			"durable": 3,
			"waterproof": 1,
			"breathable": 5,
			"weight": 5
		},
		"op": {
			"packingvolume": 5,
			"expeditionproof": 2,
			"freedomofmovement": 5,
			"versatility": 5,
			"altitude": 2
		},
		"fabrics": "Polartec® Power Stretch® Fleece Polartec® Power GridTM Fleece",
		"features": [
			"1 chest poket with zipper",
			"Full zipper",
			"Ultrasonic seams"
		],
		"padding": "0"
	},
	"TSW6001": {
		"id": "TSW6001",
		"title": "TSW6001",
		"type": "TS",
		"collection": "W",
		"season": "W",
		"gender": "M",
		"line": "SIBU",
		"purpose": "MID",
		"colors": [
			"BZ",
			"CC",
			"TE",
			"BK"
		],
		"sizes": [
			"46 - 54",
			"XS - XL"
		],
		"name": "Combat Shirt",
		"description": "Lorem ipsum This very comfortable jacket is made for ski touring, hiking and trekking. With 3 pockets placed on the outside and 4 pockets on the inside.",
		"cpbl": {
			"windproof": 1,
			"durable": 3,
			"waterproof": 1,
			"breathable": 5,
			"weight": 4
		},
		"op": {
			"packingvolume": 4,
			"expeditionproof": 5,
			"freedomofmovement": 5,
			"versatility": 5,
			"altitude": 2
		},
		"fabrics": [
			"Polartec® Power GridTM Fleece",
			"CORDURA® 4-way Stretch"
		],
		"features": [
			"2 big mesh pockets",
			"Half zipper",
			"Laser perforated back panel",
			"(for maximum ventilation) Bonded stretch CORDURA® reinforcement pads at shoulders"
		],
		"padding": "0"
	},
	"TSW6002": {
		"id": "TSW6002",
		"title": "TSW6002",
		"type": "TS",
		"collection": "W",
		"season": "W",
		"gender": "M",
		"line": "MAIWA",
		"purpose": "MID",
		"colors": [
			"BL",
			"BK",
			"DK",
			"RS",
			"TE"
		],
		"sizes": [
			"46 - 54",
			"XS - XL"
		],
		"name": "Thermo Stretch Fleece",
		"description": "Lorem ipsum This very comfortable jacket is made for ski touring, hiking and trekking. With 3 pockets placed on the outside and 4 pockets on the inside.",
		"cpbl": {
			"windproof": 1,
			"durable": 3,
			"waterproof": 1,
			"breathable": 5,
			"weight": 3
		},
		"op": {
			"packingvolume": 3,
			"expeditionproof": 3,
			"freedomofmovement": 5,
			"versatility": 5,
			"altitude": 4
		},
		"fabrics": [
			"Polartec® Power Stretch® Fleece",
			"Polartec® Power GridTM Fleece"
		],
		"features": [
			"1 chest pocket with zipper",
			"Half zipper"
		],
		"padding": "0"
	},
	"TSW6003": {
		"id": "TSW6003",
		"title": "TSW6003",
		"type": "TS",
		"collection": "W",
		"season": "W",
		"gender": "M",
		"line": "MAIWA",
		"purpose": "MID",
		"colors": [
			"CC",
			"BK",
			"DA",
			"DK"
		],
		"sizes": [
			"46 - 54",
			"XS - XL"
		],
		"name": "MultiPurpose Power Stretch Fleece",
		"description": "Lorem ipsum This very comfortable jacket is made for ski touring, hiking and trekking. With 3 pockets placed on the outside and 4 pockets on the inside.",
		"cpbl": {
			"windproof": 1,
			"durable": 3,
			"waterproof": 1,
			"breathable": 5,
			"weight": 4
		},
		"op": {
			"packingvolume": 3,
			"expeditionproof": 2,
			"freedomofmovement": 5,
			"versatility": 5,
			"altitude": 3
		},
		"fabrics": [
			"Polartec® Power Stretch® Fleece",
			"CORDURA® 4-way Stretch"
		],
		"features": [
			"2 chest pockets with zippers",
			"Half zipper"
		],
		"padding": "0"
	},
	"TSW6501": {
		"id": "TSW6501",
		"title": "TSW6501",
		"type": "TS",
		"collection": "W",
		"season": "W",
		"gender": "W",
		"line": "SIBU",
		"purpose": "MID",
		"colors": [
			"CC",
			"PB",
			"RS"
		],
		"sizes": [
			"34 - 42",
			"XS - XL"
		],
		"name": "Combat Shirt",
		"description": "Lorem ipsum This very comfortable jacket is made for ski touring, hiking and trekking. With 3 pockets placed on the outside and 4 pockets on the inside.",
		"cpbl": {
			"windproof": 1,
			"durable": 3,
			"waterproof": 1,
			"breathable": 5,
			"weight": 4
		},
		"op": {
			"packingvolume": 4,
			"expeditionproof": 5,
			"freedomofmovement": 5,
			"versatility": 5,
			"altitude": 2
		},
		"fabrics": [
			"Polartec® Power GridTM Fleece",
			"CORDURA® 4-way Stretch"
		],
		"features": [
			"2 big mesh pockets",
			"Full zipper",
			"Laser perforated back panel",
			"(for maximum ventilation)",
			"Bonded stretch CORDURA®",
			"Reinforcement pads at shoulders"
		],
		"padding": "0"
	},
	"TSW6502": {
		"id": "TSW6502",
		"title": "TSW6502",
		"type": "TS",
		"collection": "W",
		"season": "W",
		"gender": "W",
		"line": "MAIWA",
		"purpose": "MID",
		"colors": [
			"DR",
			"MU",
			"PB"
		],
		"sizes": [
			"34 - 42",
			"XS - XL"
		],
		"name": "Thermo Stretch Fleece",
		"description": "Lorem ipsum This very comfortable jacket is made for ski touring, hiking and trekking. With 3 pockets placed on the outside and 4 pockets on the inside.",
		"cpbl": {
			"windproof": 1,
			"durable": 3,
			"waterproof": 1,
			"breathable": 5,
			"weight": 3
		},
		"op": {
			"packingvolume": 3,
			"expeditionproof": 3,
			"freedomofmovement": 5,
			"versatility": 5,
			"altitude": 4
		},
		"fabrics": [
			"Polartec® Power Stretch® Fleece",
			"Polartec® Power GridTM Fleece"
		],
		"features": "Full zipper",
		"padding": "0"
	},
	"TSW6503": {
		"id": "TSW6503",
		"title": "TSW6503",
		"type": "TS",
		"collection": "W",
		"season": "W",
		"gender": "W",
		"line": "MAIWA",
		"purpose": "MID",
		"colors": [
			"BK",
			"BZ",
			"DA",
			"DR",
			"RS"
		],
		"sizes": [
			"34 - 42",
			"XS - XL"
		],
		"name": "MultiPurpose Power Stretch Fleece",
		"description": "Lorem ipsum This very comfortable jacket is made for ski touring, hiking and trekking. With 3 pockets placed on the outside and 4 pockets on the inside.",
		"cpbl": {
			"windproof": 1,
			"durable": 3,
			"waterproof": 1,
			"breathable": 5,
			"weight": 4
		},
		"op": {
			"packingvolume": 3,
			"expeditionproof": 2,
			"freedomofmovement": 5,
			"versatility": 5,
			"altitude": 3
		},
		"fabrics": [
			"Polartec® Power Stretch Fleece",
			"CORDURA® 4-way Stretch"
		],
		"features": [
			"2 hand warmer pockets with zippers",
			"Full zipper"
		],
		"padding": "0"
	},
	"VSF6001": {
		"id": "VSF6001",
		"title": "VSF6001",
		"type": "VS",
		"collection": "W",
		"season": "F",
		"gender": "M",
		"line": "SIBU",
		"purpose": "MID",
		"colors": "BK",
		"sizes": [
			"46 - 54",
			"XS - XL"
		],
		"name": "Light Windbreaker Vest",
		"description": "Lorem ipsum This very comfortable jacket is made for ski touring, hiking and trekking. With 3 pockets placed on the outside and 4 pockets on the inside.",
		"cpbl": {
			"windproof": 5,
			"durable": 4,
			"waterproof": 3,
			"breathable": 5,
			"weight": 4
		},
		"op": {
			"packingvolume": 4,
			"expeditionproof": 5,
			"freedomofmovement": 5,
			"versatility": 5,
			"altitude": 3
		},
		"fabrics": [
			"Nylon 3 L Stretch",
			"CORDURA® Stretch Double Weave CORDURA® 4-way Stretch"
		],
		"features": [
			"2 big mesh chest pockets",
			"1 chest pockets with zipper",
			"Waterproof shoulder area with 3d mesh and ceramic print reinforcement",
			"Laser perforated back panel",
			"(for maximum ventilation)",
			"Hypalon webbing",
			"(for carabiners)"
		],
		"padding": "0"
	},
	"VSW6001": {
		"id": "VSW6001",
		"title": "VSW6001",
		"type": "VS",
		"collection": "W",
		"season": "W",
		"gender": "M",
		"line": "MAIWA",
		"purpose": [
			"INSULATION",
			"DOWN"
		],
		"colors": [
			"TE",
			"BK",
			"BL",
			"MU"
		],
		"sizes": [
			"46 - 54",
			"XS - XL"
		],
		"name": "Casual Down Vest",
		"description": "Lorem ipsum This very comfortable jacket is made for ski touring, hiking and trekking. With 3 pockets placed on the outside and 4 pockets on the inside.",
		"cpbl": {
			"windproof": 4,
			"durable": 2,
			"waterproof": 3,
			"breathable": 4,
			"weight": 3
		},
		"op": {
			"packingvolume": 3,
			"expeditionproof": 2,
			"freedomofmovement": 4,
			"versatility": 2,
			"altitude": 2
		},
		"fabrics": [
			"Nylon Light Weight Ripstop",
			"Nylon Light Weight Stretch"
		],
		"features": [
			"2 hand warmer pockets with zippers 1 inside pocket with zipper",
			"1 inside pocket with Velcro Removeable and adjustable hood"
		],
		"padding": "750 cuin traceable down"
	},
	"VSW6501": {
		"id": "VSW6501",
		"title": "VSW6501",
		"type": "VS",
		"collection": "W",
		"season": "W",
		"gender": "W",
		"line": "MAIWA",
		"purpose": [
			"INSULATION",
			"DOWN"
		],
		"colors": [
			"BK",
			"GB",
			"YS"
		],
		"sizes": [
			"34 - 42",
			"XS - XL"
		],
		"name": "Casual Down Vest",
		"description": "Lorem ipsum This very comfortable jacket is made for ski touring, hiking and trekking. With 3 pockets placed on the outside and 4 pockets on the inside.",
		"cpbl": {
			"windproof": 4,
			"durable": 2,
			"waterproof": 3,
			"breathable": 4,
			"weight": 3
		},
		"op": {
			"packingvolume": 3,
			"expeditionproof": 2,
			"freedomofmovement": 4,
			"versatility": 2,
			"altitude": 2
		},
		"fabrics": [
			"Nylon Light Weight Ripstop",
			"Nylon Light Weight Stretch",
			"CORDURA® Light Weight Ripstop"
		],
		"features": [
			"2 hand warmer pockets with zippers",
			"1 inside pocket with zipper",
			"1 inside pocket with Velcro",
			"Removeable and adjustable hood"
		],
		"padding": "750 cuin traceable down"
	},
	"TEST0001": {
		"id": "TEST0001",
		"title": "TEST0001",
		"type": "VS",
		"collection": "S",
		"season": "S",
		"gender": "W",
		"line": "MAIWA",
		"purpose": "DOWN",
		"colors": [
			"BK",
			"GB",
			"YS"
		],
		"sizes": [
			"34 - 42",
			"XS - XL"
		],
		"name": "TEST summer vest",
		"description": "Lorem ipsum This very comfortable jacket is made for ski touring, hiking and trekking. With 3 pockets placed on the outside and 4 pockets on the inside.",
		"cpbl": {
			"windproof": 4,
			"durable": 2,
			"waterproof": 3,
			"breathable": 4,
			"weight": 3
		},
		"op": {
			"packingvolume": 3,
			"expeditionproof": 2,
			"freedomofmovement": 4,
			"versatility": 2,
			"altitude": 2
		},
		"fabrics": [
			"Nylon Light Weight Ripstop",
			"Nylon Light Weight Stretch",
			"CORDURA® Light Weight Ripstop"
		],
		"features": [
			"2 hand warmer pockets with zippers",
			"1 inside pocket with zipper",
			"1 inside pocket with Velcro",
			"Removeable and adjustable hood"
		],
		"padding": "750 cuin traceable down"
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ../jsonCMS/processed/catalog-2016.en.json
 ** module id = 585
 ** module chunks = 0
 **/